import api from './api';

const API_URL = '/admin';

export const getMerchants = async () => {
    const response = await api.get(`${API_URL}/merchants`);
    return response.data;
};

export const getTerminals = async () => {
    const response = await api.get(`${API_URL}/devices`);
    return response.data;
};

const affiliationEndpoints = [
    '/afiliaciones',
    '/affiliations',
    '/afiliaciones/',
    '/affiliations/'
];

const normalizeAffiliationsResponse = (data) => {
    if (Array.isArray(data)) {
        return data;
    }

    if (Array.isArray(data?.data)) {
        return data.data;
    }

    if (Array.isArray(data?.affiliations)) {
        return data.affiliations;
    }

    return [];
};

export const getAffiliations = async () => {
    let lastError = null;

    for (const endpoint of affiliationEndpoints) {
        try {
            const response = await api.get(`${API_URL}${endpoint}`);
            return normalizeAffiliationsResponse(response.data);
        } catch (error) {
            lastError = error;

            const status = error?.response?.status;
            // Errores de autenticación/autorización o del servidor no se resuelven cambiando endpoint.
            if (status === 401 || status === 403 || status >= 500) {
                throw error;
            }
        }
    }

    throw lastError || new Error('No se pudo obtener afiliaciones.');
};

export const createMerchant = async (merchantData) => {
    const response = await api.post(`${API_URL}/merchants`, merchantData);
    return response.data;
};

export const updateMerchant = async (merchantId, merchantData) => {
    const response = await api.patch(`${API_URL}/merchants/${merchantId}`, merchantData);
    return response.data;
};

export const createTerminal = async (terminalData) => {
    const response = await api.post(`${API_URL}/devices`, terminalData);
    return response.data;
};

export const createAffiliation = async (affiliationData) => {
    let lastError = null;

    for (const endpoint of affiliationEndpoints) {
        try {
            const response = await api.post(`${API_URL}${endpoint}`, affiliationData);
            return response.data;
        } catch (error) {
            lastError = error;

            const status = error?.response?.status;
            if (status === 401 || status === 403 || status >= 500) {
                throw error;
            }
        }
    }

    throw lastError || new Error('No se pudo crear la afiliación.');
};

export const createAffiliationsBulk = async (affiliations) => {
    let lastError = null;

    for (const endpoint of affiliationEndpoints) {
        const normalizedEndpoint = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint;

        try {
            const response = await api.post(`${API_URL}${normalizedEndpoint}/bulk`, { affiliations });
            return response.data;
        } catch (error) {
            lastError = error;

            const status = error?.response?.status;
            if (status === 401 || status === 403 || status >= 500 || status === 409) {
                throw error;
            }
        }
    }

    throw lastError || new Error('No se pudo crear la carga masiva de afiliaciones.');
};

export const updateAffiliation = async (affiliationId, affiliationData) => {
    let lastError = null;

    for (const endpoint of affiliationEndpoints) {
        const normalizedEndpoint = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint;

        try {
            const response = await api.patch(`${API_URL}${normalizedEndpoint}/${affiliationId}`, affiliationData);
            return response.data;
        } catch (error) {
            lastError = error;

            const status = error?.response?.status;
            if (status === 401 || status === 403 || status >= 500) {
                throw error;
            }
        }
    }

    throw lastError || new Error('No se pudo actualizar la afiliación.');
};
